import { Box } from '@material-ui/core';
import { HomeImprovementAssetDetails } from '@nemuru-eng/js-api-client';

import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { Text } from '@/components/shared/components/Text';

interface HomeImprovementDetailsFormProps extends FormGridOptions {
  assetDetails: HomeImprovementAssetDetails;
}

export const HomeImprovementDetailsForm = ({
  assetDetails,
  fullWidth,
  fieldVariant,
}: HomeImprovementDetailsFormProps) => {
  return (
    <>
      <Box pt={2}>
        <FormGridContainer fullWidth={fullWidth} fieldVariant={fieldVariant}>
          <TextFormField name={'type'} label={'TYPE'} value={<Text tId={assetDetails.type} />} />
          <TextFormField
            name={'workSiteAddress'}
            label={'WORKSITE_ADDRESS'}
            value={assetDetails.workSiteAddress}
            tooltipTitle={
              <>
                <Text tId={'WORKSITE_ADDRESS'} />: {assetDetails.workSiteAddress}
              </>
            }
          />
          <TextFormField name={'description'} label={'DESCRIPTION'} value={assetDetails.description} />
        </FormGridContainer>
      </Box>
    </>
  );
};
